module.exports = __webpack_public_path__ + "img/rocket.307a76ca.png";